import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handleChangeValue, handlePost } from '../../../../utils/AxiosUtil';
import * as enums from '../../../../utils/EnumMapping';
import * as util from '../../../../utils/Util';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import PaymentMethodFormControl from '../../../common/inputfields/PaymentMethodFormControl';

class NewTax extends Component {
    fields = ["amount", "selectedPaymentMethod", "paymentDeadline"];

    state = {
        newAgain: false,
        selectedTaxType: {},
        selectedPaymentMethod: enums.outPaymentMethods[1],
        amount: '',
        comment: '',
        paymentDeadline: new Date(),
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedTaxType: {},
            selectedPaymentMethod: enums.outPaymentMethods[1],
            amount: '',
            comment: '',
            paymentDeadline: new Date(),
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/tax';
        const requestObject = {
            "taxTypeId": this.state.selectedTaxType.value,
            "amount": util.toNumber(this.state.amount),
            "paymentDeadline": util.toDateFormat(this.state.paymentDeadline),
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "comment": this.state.comment,
        };
        handlePost(path, requestObject, this);
    };

    promiseTaxTypeOptions = async () => {
        const response = await axios.get('/api/taxtypes')
        const renamedCustomers = [];
        response.data.map((taxtype) =>
            renamedCustomers.push({
                label: taxtype.publicId ? taxtype.publicId + '-' + taxtype.name : taxtype.name,
                value: taxtype.privateId,
            }));
        return renamedCustomers;
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseTaxTypeOptions}
                            onChange={(e, v) => handleChangeValue(v, "selectedTaxType", this)}
                            label={'Adónem'}
                            value={this.state.selectedTaxType}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Összeg"
                            value={this.state.amount}
                            errors={this.state.errors}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="payment-deadline-date"
                            name="paymentDeadline"
                            label="Fizetési határidő"
                            errors={this.state.errors}
                            value={this.state.paymentDeadline}
                            onChange={v => handleChangeValue(v, "paymentDeadline", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewTax);
